import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SharedFunctions } from 'src/app/shared/shared.functions';

import { SeguridadService } from '../../shared/services';
import { ForgotUserDto } from '../../shared/model';

@Component({
  selector: 'app-dialogOlvidoUsuario',
  templateUrl: 'dialogOlvidoUsuario.component.html'
})

export class DialogOlvidoUsuarioComponent implements OnInit {

  formGroup: FormGroup;
  private entity: ForgotUserDto;
  buttonEnabled: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<DialogOlvidoUsuarioComponent>,
    private service: SeguridadService,
    private sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() { 
    this.buildForm();
  }

  buildForm(){
    this.formGroup = this.formBuilder.group({
     'UserMail': ["", Validators.required]
    });
  }

  onGuardar(){
    if (this.formGroup.valid) {
        var value = { ... this.entity, ... this.formGroup.getRawValue() };
        this.buttonEnabled = false;

        this.service.forgotUser(value).subscribe(data => {
          this.buttonEnabled = true;
          if(data.Success) {
            let result = data.Result;

            if (result)
              this.sharedFunctions.showMessage("Se envió un mail a la casilla ingresada previamente con sus datos de usuario", 'Recordatorio de Usuario');

            this.dialogRef.close(result);
          }
          else{
            this.sharedFunctions.showMessage("Ocurrió un error ejecutando la operación", 'Error');
          }
        },
        (err: HttpErrorResponse) => {
          this.buttonEnabled = true;
          this.sharedFunctions.handleError(err, true);
        })
    }
    else {
      this.sharedFunctions.showMessage("Debe completar todos los campos requeridos", 'Error');
    }
  }
  
  onCancelar(){
    this.dialogRef.close(null);
  }

  getErrorUserMail() {
    return this.formGroup.get('UserMail').hasError('required') ? 'Debe ingresar su mail registrado en el sistema' : '';
  }
}